import React, { Suspense, lazy } from 'react'

import useAxios from 'hooks/useAxios'
import useFeatureToggle from 'hooks/useFeatureToggle'

const UpgradePlanModal = lazy(() => import('./index'))

interface UpgradePlanModalContainerProps {
  isOpen: boolean
  onClose: () => void
}

export default function UpgradePlanModalContainer({
  isOpen,
  onClose,
}: UpgradePlanModalContainerProps) {
  if (!isOpen) {
    return null
  }
  return <UpgradePlanModalData onClose={onClose} />
}

function UpgradePlanModalData({ onClose }: { onClose: () => void }) {
  const { data: billing } = useAxios({ url: 'billing/' })
  const { data: plans } = useAxios({ url: 'billing/plans/' })
  const { enableNewBillingPlan, enableNewPlanCardUI } = useFeatureToggle()

  if (!billing || !plans) {
    return null
  }

  const hasCard = Boolean(billing.card)

  return (
    <Suspense fallback={null}>
      <UpgradePlanModal
        onClose={onClose}
        billing={billing}
        plans={plans}
        hasCard={hasCard}
        enableNewBillingPlan={enableNewBillingPlan}
        enableNewPlanCardUI={enableNewPlanCardUI}
      />
    </Suspense>
  )
}



// WEBPACK FOOTER //
// ./src/components/UpgradePlanModal/container.tsx